import { Inline } from "PFComponents/containers";
import React, { Fragment, ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { BreadcrumbItem, BreadcrumbItemProps } from "./breadcrumb_item";
import css from "./breadcrumbs.module.scss";

type BreadcrumbChildren =
  | ReactElement<BreadcrumbItemProps, typeof BreadcrumbItem>
  | ReactElement<BreadcrumbItemProps, typeof BreadcrumbItem>[]
  | null
  | (ReactElement<BreadcrumbItemProps, typeof BreadcrumbItem> | null)[];

type BreadcrumbProps = {
  children: BreadcrumbChildren;
};

export const Breadcrumbs = ({ children }: BreadcrumbProps) => {
  const { t } = useTranslation("core", { keyPrefix: "components.breadcrumbs" });
  const childrenArray = React.Children.toArray(children);

  return (
    <nav aria-label={t("ariaLabel")}>
      <Inline as="ol" className={css.breadcrumbsList} gap="spacingSm" alignItems="center">
        {childrenArray.map((child, index) => (
          <Fragment key={index}>
            {child}
            {index < childrenArray.length - 1 && <span aria-hidden="true">/</span>}
          </Fragment>
        ))}
      </Inline>
    </nav>
  );
};
